import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Document, Signer } from '@app/models';
import { DocumentService, AppService, NotyService } from '@app/services';
import { SetMissingUserInfoModalService } from '@app/shared';
import { TranslateService } from '@ngx-translate/core';

export type ModalResult = void;
export interface ModalPublicProperties {
  document: Document;
  currentSigner?: Signer;
  signerHasFieldsToFill?: boolean;
}

@Component({
  selector: 'app-document-created-modal',
  templateUrl: './document-created-modal.component.html',
  styleUrls: ['./document-created-modal.component.scss'],
  standalone: false
})
export class DocumentCreatedModalComponent implements ModalPublicProperties {
  @Input() document: Document;
  @Input() currentSigner: Signer;
  @Input() signerHasFieldsToFill: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    public appService: AppService,
    public documentService: DocumentService,
    public setMissingUserInfoModalService: SetMissingUserInfoModalService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  copySignatureLink(signerName: string): void {
    this.notyService.success(this.translateService.instant('notyService.signerLinkCopied', { signerName }), 2000);
  }
}
